export enum WatchInterestsState {
    YES = 'YES',
    SHALLOW = 'SHALLOW',
    ENO = 'ENO',
    INO = 'INO',
}
